import { BaseEntity } from "yt-ng-framework";

export class VrstaVozila extends BaseEntity{
    constructor(){
        super();
    }
    Naziv: string = null;

    Deserialize(input: any){
        this.ID = input.ID;
        this.Naziv = input.Naziv;
        return this;
    }

    Serialize(input: VrstaVozila){
        return input;
    }
}